import car1 from "../assets/images/cars/1.png";
import car2 from "../assets/images/cars/2.png";
import car3 from "../assets/images/cars/3.png";
import car4 from "../assets/images/cars/4.png";
import team1 from "../assets/images/team/t1.png";
import team2 from "../assets/images/team/t2.png";
import team3 from "../assets/images/team/t3.png";
import avatar1 from "../assets/images/avatar/1.png";
import avatar2 from "../assets/images/avatar/2.png";
import avatar3 from "../assets/images/avatar/3.png";
import avatar4 from "../assets/images/avatar/4.png";
import blog1 from "../assets/images/blogs/b1.png";
import blog2 from "../assets/images/blogs/b2.png";

export const SERVICES = [
	{
		title: "Many Pickup Location",
		description:
			"There are many variations of they passages of Lorem Ipsum available.",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className="w-6 h-6"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
				/>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
				/>
			</svg>
		),
		iconBig: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className="w-10 h-10"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
				/>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
				/>
			</svg>
		),
	},
	{
		title: "Best Price Guarantee",
		description:
			"There are many variations of they passages of Lorem Ipsum available.",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className="w-6 h-6"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z"
				/>
			</svg>
		),
		iconBig: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className="w-10 h-10"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M6.633 10.5c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 012.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 00.322-1.672V3a.75.75 0 01.75-.75A2.25 2.25 0 0116.5 4.5c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 01-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 00-1.423-.23H5.904M14.25 9h2.25M5.904 18.75c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 01-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 10.203 4.167 9.75 5 9.75h1.053c.472 0 .745.556.5.96a8.958 8.958 0 00-1.302 4.665c0 1.194.232 2.333.654 3.375z"
				/>
			</svg>
		),
	},
	{
		title: "Customer Satisfaction",
		description:
			"There are many variations of they passages of Lorem Ipsum available.",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className="w-6 h-6"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
				/>
			</svg>
		),
		iconBig: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className="w-10 h-10"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
				/>
			</svg>
		),
	},
	{
		title: "No Hidden Cost",
		description:
			"There are many variations of they passages of Lorem Ipsum available.",
		icon: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className="w-6 h-6"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
				/>
			</svg>
		),
		iconBig: (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				strokeWidth={1.5}
				stroke="currentColor"
				className="w-10 h-10"
			>
				<path
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
				/>
			</svg>
		),
	},
];

export const CARS = [
	{
		img: car1,
		title: "Alcazar Platinum 7",
		baseRate: "$105.00 /Day",
		seatCapacity: "4 Seat",
		carType: "Automatic",
		model: "2022",
		miles: "24 km",
	},
	{
		img: car2,
		title: "Audi RS e-tron GT",
		baseRate: "$105.00 /Day",
		seatCapacity: "4 Seat",
		carType: "Automatic",
		model: "2022",
		miles: "24 km",
	},
	{
		img: car3,
		title: "Chevrolet Camaro",
		baseRate: "$105.00 /Day",
		seatCapacity: "4 Seat",
		carType: "Automatic",
		model: "2022",
		miles: "24 km",
	},
	{
		img: car4,
		title: "Mitsubishi Outlander",
		baseRate: "$105.00 /Day",
		seatCapacity: "4 Seat",
		carType: "Automatic",
		model: "2022",
		miles: "24 km",
	},
];

export const TEAM = [
	{
		img: team1,
		title: "Erik Genie",
		designation: "CEO & Founder",
	},
	{
		img: team2,
		title: "Helen Stefone",
		designation: "Company Manager",
	},
	{
		img: team3,
		title: "Harold Franky",
		designation: "Marketing Manager",
	},
];

export const TESTIMONIALS = [
	{
		description:
			"There are many variations of passages of Lorem Ipsum available, but the majority have variations of passages of Lorem Ipsum suffered alteration in some variations of passages form.",
		img: avatar1,
		title: "John Waxley",
		designation: "Accountant",
	},
	{
		description:
			"There are many variations of passages of Lorem Ipsum available, but the majority have variations of passages of Lorem Ipsum suffered alteration in some variations of passages form.",
		img: avatar2,
		title: "Paul Youngter",
		designation: "Manager",
	},
	{
		description:
			"There are many variations of passages of Lorem Ipsum available, but the majority have variations of passages of Lorem Ipsum suffered alteration in some variations of passages form.",
		img: avatar3,
		title: "Ronda Young",
		designation: "Accountant",
	},
	{
		description:
			"There are many variations of passages of Lorem Ipsum available, but the majority have variations of passages of Lorem Ipsum suffered alteration in some variations of passages form.",
		img: avatar4,
		title: "Julia Heartbreak",
		designation: "Accountant",
	},
];

export const BLOGS = [
	{
		img: blog1,
		title: "Renting A Car With A Debit Card Is Not A Dream!",
		description:
			"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
		authorName: "Jack Rifer",
		date: "25 June, 2023",
		category: ["Rent a Car", "Cab Services"],
	},
	{
		img: blog2,
		title: "Drive Safe, Arrive Safe: Tips to Avoid Road Accidents",
		description:
			"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
		authorName: "Jack Rifer",
		date: "24 June, 2023",
		category: ["Road Safety", "Road Accidents"],
	},
];

export const QNA = [
	{
		id: 1,
		que: "Are car rentals available for self-drive?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
	{
		id: 2,
		que: "Which cities are open for car rental?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
	{
		id: 3,
		que: "Is car rental safe during the Pandemic?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
	{
		id: 4,
		que: "What is the current process of car rental during the COVID-19?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
	{
		id: 5,
		que: "How does car rental return work during the Coronavirus outbreak?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
	{
		id: 6,
		que: "What guidelines does a car rental company follow for cleaning and sanitation?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
	{
		id: 7,
		que: "Can I cancel my car rental?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
	{
		id: 8,
		que: "Can I switch the car during COVID19?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
	{
		id: 9,
		que: "Can I extend my car rental booking?",
		ans: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.",
	},
];
